import { Roles } from './roles';
import { SidebarItem } from '../../interfaces/primeng/sidebar-item';

export const COREACT_MENU_ITEMS: SidebarItem[] = [
  {
    items: [
      {
        label: 'Dashboard',
        icon: 'fa-solid fa-table-cells-large',
        routerLink: ['/dashboard'],
        roles: [Roles.Administrator,Roles.Guest],
      },
    ],
  },
  {
    items: [
      {
        label: 'Claims',
        icon: 'fas fa-cogs',
        routerLink: ['/case-table'],
        roles: [
          Roles.Administrator,
          Roles.Adjuster,
          Roles.Investigator,
          Roles.Guest,
          Roles.Secretary,
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'YSAE',
        icon: 'fas fa-solid fa-folder-tree',
        routerLink: ['/ysae-search'],
        roles: [
          Roles.Administrator,
          Roles.Adjuster,
          Roles.CaseManager,
          Roles.Investigator,
          Roles.Guest,
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'Watchlist',
        icon: 'fas fa-solid fa-user-shield',
        routerLink: ['/watch-list'],
        roles: [Roles.Administrator, Roles.Investigator],
      },
    ],
  },
  {
    items: [
      {
        label: 'Reports',
        icon: 'fas fa-chart-bar',
        routerLink: ['/reports'],
        roles: [Roles.Administrator, Roles.Investigator, Roles.Guest],
      },
    ],
  },
  {
    items: [
      {
        label: 'Network Analysis',
        icon: 'fas fa-solid fa-network-wired',
        routerLink: ['/networkAnalysis'],
        roles: [Roles.Administrator, Roles.Investigator],
      },
    ],
  },
  {
    items: [
      {
        label: 'Settings',
        icon: 'fas fa-edit',
        roles: [Roles.Administrator],
        routerLink: ['**'],
        items: [
          {
            label: 'Manage Users',
            icon: 'bullet bullet-dot',
            routerLink: ['/manage-users'],
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'About',
        icon: 'fas fa-circle-info',
        routerLink: ['/', { outlets: { modal: ['about-page'] } }],
        roles: [
          Roles.Administrator,
          Roles.CaseManager,
          Roles.Investigator,
          Roles.Guest,
          Roles.Secretary,
          Roles.Adjuster
        ],
      },
    ],
  },
];
